"use client";
import e from "react";
var t = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, d = e.createContext && /* @__PURE__ */ e.createContext(t);
export {
  t as DefaultContext,
  d as IconContext
};
